import React from "react";
import { Table, Divider, Input, Button, Tag, Tooltip, message } from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { StatusSwitch } from "../Common/StatusSwitch";
import {
  defaultSort,
  getTablePagesize,
  setTablePageSize,
} from "../../Constants/Utilities";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { convertServiceTierOfferingData } from "../../Helpers/ServiceTierHelpers";
import {
  EntityStatus,
  ServiceTierActions,
  StatusFilters,
  TablePages,
  TablePageSizes,
} from "../../Constants/Constants";
import { apiCallback } from "../../ApiHandlers/Common";
import { BreadCrumbs } from "../Common/BreadCrumbs";

class ListServiceTier extends React.Component {
  constructor(props) {
    super(props);
    console.log("ListServiceTier props", props);
    this.state = {
      expandedRowKeys: [],
      serviceTierData: props.serviceTierData,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.serviceTierData !== this.props.serviceTierData) {
      this.setState({ serviceTierData: this.props.serviceTierData });
    }
  }

  getColumns = () => {
    const isModelFilter = !!this.props.deviceModelRecord;
    return [
      {
        title: "Service Tier Name",
        dataIndex: "serviceTierName",
        sorter: (a, b) => defaultSort(a.serviceTierName, b.serviceTierName),
        defaultSortOrder: "ascend",
        render: (value, record) => (
          <Button
            type="link"
            onClick={this.props.onActionClick(ServiceTierActions.view, record)}
          >
            {value}
          </Button>
        ),
      },
      ...(isModelFilter
        ? []
        : [
            {
              title: "Actions",
              dataIndex: "actions",
              align: "center",
              render: (_, record) => (
                <div className="entity-list-actions">
                  <Tooltip title="Edit Tier">
                    <EditOutlined
                      onClick={this.props.onActionClick(
                        ServiceTierActions.edit,
                        record
                      )}
                    />
                  </Tooltip>
                </div>
              ),
            },
          ]),
    ];
  };

  getExpandedColumns = () => {
    const isModelFilter = !!this.props.deviceModelRecord;
    return [
      {
        title: "Device Model",
        dataIndex: "modelNumber",
        sorter: (a, b) => defaultSort(a.modelNumber, b.modelNumber),
      },
      {
        title: "Offering Name",
        dataIndex: "offeringName",
        sorter: (a, b) => defaultSort(a.offeringName, b.offeringName),
      },
      {
        title: isModelFilter ? "Status" : "Active",
        dataIndex: "status",
        align: "center",
        filters: StatusFilters,
        onFilter: (value, record) => record.status === value,
        render: isModelFilter
          ? (status) => (
              <Tag color={status === EntityStatus.ACTIVE ? "green" : "red"}>
                {status}
              </Tag>
            )
          : StatusSwitch(this.props.onStatusChange),
      },
    ];
  };

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { serviceTierData } = this.props;
    if (!!text) {
      const filteredData = serviceTierData.filter((item) =>
        item.serviceTierName?.toLowerCase().includes(text.toLowerCase())
      );
      this.setState({ serviceTierData: filteredData });
      return;
    }
    this.setState({ serviceTierData });
  };

  updateServiceTierOfferingList(serviceTierId) {
    console.log("updateList...", serviceTierId);
    const serviceTierData = [...this.state.serviceTierData];
    const tierRecord = serviceTierData.filter(
      (item) => item.serviceTierId === serviceTierId
    )[0];
    tierRecord.offeringData.loading = true;
    this.setState({ serviceTierData });
    const errorCallback = () => {
      tierRecord.offeringData.loading = false;
      this.setState({ serviceTierData });
      message.error("Error fetching Tier Offering list");
    };
    try {
      this.props.serviceTierApi.getServiceTierById(
        serviceTierId,
        apiCallback({
          history: this.props.history,
          errorCallback,
          successCallback: (data) => {
            const offeringData = convertServiceTierOfferingData(data);
            console.log("updateDataList data", offeringData);
            tierRecord.offeringData.data = offeringData;
            tierRecord.offeringData.loading = false;
            this.setState({ serviceTierData });
          },
        })
      );
    } catch (error) {
      errorCallback();
    }
  }

  onRowExpand = (expanded, record) => {
    const { serviceTierId } = record;
    console.log("onRowExpand", expanded, serviceTierId);
    const expandedRowKeys = expanded ? [record.serviceTierId] : [];
    if (expanded) {
      const tierRecord = this.state.serviceTierData.filter(
        (item) => item.serviceTierId === serviceTierId
      )[0];
      if (!tierRecord.offeringData.data) {
        this.updateServiceTierOfferingList(serviceTierId);
      }
    }
    this.setState({ expandedRowKeys });
  };

  expandedRowRender = (record) => {
    const { serviceTierId } = record;
    const { serviceTierData } = this.state;
    const tierRecord = serviceTierData.filter(
      (item) => item.serviceTierId === serviceTierId
    );
    return (
      <Table
        bordered={true}
        className="entity-table child-entity-table"
        columns={this.getExpandedColumns()}
        loading={tierRecord[0].offeringData.loading}
        dataSource={tierRecord[0].offeringData.data}
        pagination={{ pageSize: 5, size: "small" }}
      />
    );
  };

  render() {
    const { serviceTierData, expandedRowKeys } = this.state;
    const {
      serviceTierDataLoading,
      onActionClick,
      deviceModelRecord,
      onParentActionClick,
      parentBread,
    } = this.props;
    const isModelFilter = !!deviceModelRecord;

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs
            headers={parentBread}
            onParentActionClick={
              isModelFilter ? onParentActionClick(null, null) : null
            }
          />
        </div>

        <Divider className="divider" />
        {isModelFilter && (
          <div className="page-parent-title-container">
            <label>Device Model: {deviceModelRecord.modelNumber}</label>
          </div>
        )}
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Search:</span>
            <Input
              allowClear
              className="search-input"
              placeholder="Enter Service Tier Name"
              onChange={this.onSerchTextChange}
              suffix={<SearchOutlined style={{ fontSize: 16 }} />}
            />
          </div>
          {!isModelFilter && (
            <div className="add-container">
              <Button
                type="primary"
                icon={<PlusCircleOutlined />}
                onClick={onActionClick(ServiceTierActions.add, null)}
              >
                Add Service Tier
              </Button>
            </div>
          )}
        </div>
        <Table
          bordered
          size="small"
          columns={this.getColumns()}
          className="entity-table"
          loading={
            serviceTierDataLoading && { tip: "Fetching Service Tier list..." }
          }
          dataSource={serviceTierData}
          expandable={{
            expandRowByClick: true,
            onExpand: this.onRowExpand,
            expandedRowKeys: expandedRowKeys,
            expandedRowRender: this.expandedRowRender,
          }}
          pagination={{
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            defaultPageSize: getTablePagesize(TablePages.listServiceTier),
            pageSizeOptions: TablePageSizes,
            onChange: (_, pageSize) =>
              setTablePageSize(TablePages.listServiceTier, pageSize),
          }}
        />
      </div>
    );
  }
}

ListServiceTier.propTypes = {
  deviceModelRecord: PropTypes.object,
  onParentActionClick: PropTypes.func,
  serviceTierData: PropTypes.array,
  serviceTierDataLoading: PropTypes.bool,
  onActionClick: PropTypes.func,
  onStatusChange: PropTypes.func,
  parentBread: PropTypes.array,

  serviceTierApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  serviceTierApi: state.apis.serviceTierApi,
});
const connectedListServiceTier = connect(mapStateToProps)(ListServiceTier);
export default withRouter(connectedListServiceTier);
